import { Injectable, isDevMode } from '@angular/core';
import { Http, Jsonp, Headers, RequestOptions } from '@angular/http';
import 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Config } from '../classes/config';

@Injectable()
export class VersionService {

  constructor(private _http: Http, private _jsonp: Jsonp) { }

  activeVersion(): number {
    if (isDevMode()) {
      return parseInt(sessionStorage.getItem('versionId'));
    }
    else {
      return Config.version;
    }
  }

  get() {
    return this._http.get(`${Config.apiUrl}/Version/?newData=1&callback=JSONP_CALLBACK`)
      .map(resp => resp.json());
  }

  auth(version: number, username: string, password: string) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    const params = {
      verId: version,
      username: username,
      password: password
    };

    return this._http.post(`${Config.apiUrl}/Version`, JSON.stringify(params), options)
      .map(resp => resp.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/version.service.ts